import { Grid } from '@simplywallst/ui-core';
import { CompanyNameWithIcon } from '../CompanyNameWithIcon';
import { NarrativeTabs } from '../NarrativeTabs';

import { NarrativeForm } from '../../utils/schema';
import { NarrativeCompany } from '../../hooks/useNarrativeById';

type Props = {
  authorDisplayName: string;
  company: NarrativeCompany;
  onChange: (values: Partial<NarrativeForm>) => void;
  readOnly: boolean;
  values: NarrativeForm;
  onReset: () => void;
};

export const NarrativeSidebar = ({
  authorDisplayName,
  company,
  onChange,
  readOnly,
  values,
  onReset,
}: Props) => {
  return (
    <Grid
      backgroundColor="noir"
      borderRadius="x0"
      borderRadiusLg="x2"
      templateRows="max-content max-content max-content"
      height="min-content"
    >
      <Grid
        paddingX="x2"
        paddingTop="x2"
        paddingBottom="x1"
        justifyContent="flex-start"
      >
        <CompanyNameWithIcon
          name={company.name}
          tickerSymbol={company.tickerSymbol}
          websiteUrl={company.info.url}
          canonicalURL={company.canonicalURL}
        />
      </Grid>
      <NarrativeTabs
        company={company}
        onChange={onChange}
        values={values}
        readOnly={readOnly}
        authorDisplayName={authorDisplayName}
        onReset={onReset}
      />
    </Grid>
  );
};
